module.exports = __webpack_public_path__ + "img/absa-logo.cf32df55.svg";